import { render, staticRenderFns } from "./NoHeader.vue?vue&type=template&id=29c4fc18&"
import script from "./NoHeader.vue?vue&type=script&lang=js&"
export * from "./NoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports